import { render, staticRenderFns } from "./BlueButton.vue?vue&type=template&id=0f824500&scoped=true"
import script from "./BlueButton.vue?vue&type=script&lang=js"
export * from "./BlueButton.vue?vue&type=script&lang=js"
import style0 from "./BlueButton.vue?vue&type=style&index=0&id=0f824500&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f824500",
  null
  
)

export default component.exports